import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import 'rxjs';
import {HttpClientService} from '../../../../_shared/services/http-client.service';
import {Asset, Service, Subcontractor, User} from '../../../../_shared/model';
import {HelperService} from '../../../../_shared/services';
import {map} from 'rxjs/operators';

@Injectable()
export class CommonService {
    data: any;
    token: any;

    constructor(private httpClient: HttpClientService, private helper: HelperService) {}

    public getAllAssets(cid: number): Observable<Asset[]> {
        return this.httpClient.get(this.helper.getApiUrl(2) + '/contractors/' + cid + '/assets');
    }

    public getAllSubcontractors(cid: number, showAll: boolean = false): Observable<Subcontractor[]> {
        if (showAll) {
            return this.httpClient.get(this.helper.getApiUrl(2) + '/contractors/' + cid + '/subcontractors');
        }
        return this.httpClient.get(this.helper.getApiUrl(2) + '/contractors/' + cid + '/subcontractors').pipe(
            map((data) => {
                return data.filter((el) => el.active);
            }),
        );
    }

    public getServicesForContractor(cid: number): Observable<Service[]> {
        return this.httpClient.get(this.helper.getApiUrl(2) + `/contractors/${cid}/services`);
    }

    public getUserRoles(contractorid: number): Observable<any> {
        return this.httpClient.get(this.helper.getApiUrl(2) + '/roles/' + contractorid);
    }

    public getUserData(): Observable<User> {
        return this.httpClient.get(this.helper.getApiUrl(2) + '/userinfo/');
    }
}
